export default __webpack_public_path__ + "static/modal-background-menstruacion@2x-3524ab97d8619bfa22bdc78d43f1f025.png";